import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const FundamentalsOfNumberTheoryModule = () => (
  <QPhototModuleSubtopic
    title="Fundamentals of Number Theory"
    videos={[
      "https://www.youtube.com/embed/eTIT29wI6JE",
      "https://www.youtube.com/embed/9qh5FZZEEIY",
      "https://www.youtube.com/embed/-uFc7-wOplM",
      "https://www.youtube.com/embed/sDrXeCs3ghQ",
      "https://www.youtube.com/embed/osge0_lZTaY",
      "https://www.youtube.com/embed/DyOv20d4c70",
      "https://www.youtube.com/embed/Fyr9rUWhhTM",
      "https://www.youtube.com/embed/8i0UnX7Snkc",
      "https://www.youtube.com/embed/za9azzh4v9A",
      "https://www.youtube.com/embed/yKNTfeqSEhc"
    ]}
    takeaways={[]}
    questions={[
      {
        text:
          "Find GCD, variables S and T by construct a table for the following inputs using Extended Euclidean Algorithm. 291, 41"
      },
      {
        text:
          "Find the remainder for 220 + 330 + 440 + 550 + 660 mod 7 using Fermat's Little Theorem"
      },
      {
        text:
          "A hoard of gold pieces comes into the possession of’ a band of 15 pirates. When they come to divide\nup the coins, they find that 3 are left over. Their discussion of what to do with these extra coins becomes animated, and by the time some semblance of order returns there remain only 7 pirates capable of making an effective claim on the hoard. When, however, the hoard is divided between these seven it is found that 2 pieces are left over. There ensues an unfortunate repetition of the earlier\ndisagreement, but this does at least have the consequence that the 4 pirates who remain are able to divide up the hoard evenly between them. What is the minimum number of gold pieces which could have been in the hoard?"
      },
      {
        text:
          "Find 15^276 mod 97 using the method of fast modular exponentiation. Also,\ndetermine the result step-by-step and explain how the exponentiation and modular operations are applied iteratively."
      },
      {
        text:
          "Compute ϕ (8820) using the property of Euler’s Totient Function. Describe your\nsteps clearly."
      },
      {
        text:
          "Solve the following congruent equations and find the X value using Chinese\nRemainder Theorem.\nX ≡ 5 (mod 18)\nX ≡ 3 (mod 11)\nX ≡ 0 (mod 5)"
      },
      {
        text: "Write the algorithm steps of Miller-Robin algorithm."
      },
      {
        text:
          "Solve the following using suitable methods.The problem has to be solved in steps.",
          image:"/cns_1.png"
      },
      {
        text:
          "Solve the following using suitable methods.The problem has to be solved in steps.",
          image:"/cns_2.png"
      },
      {
        text: "Prove whether 7 is a primitive root of 13 in steps."
      },
      {
        text:
          "In a gift box, there were many balloons.The balloons to be distributed to children participating in a birthday party.when 11 balloons were given to each child, 5 were left over.so host starts all over again and gives 9 balloons to each child and now 7 is left over.then host gives 7 and now nothing was leaft over.Find out how many balloons were there in the gift box?"
      },
      {
        text:
          "Use Euler’s theorem to find a number ‘x’ between 0 and 28 with x^85 congruent to 6 modulo 35."
      },
      {
        text:
          "Using Successive Squaring and reducing modulo ‘n’, calculate 2^513 mod 10"
      },
      {
        text: "Find out whether the following relationship holds: 5 is a primitive root of 11"
      },
      {
        text:
          "The child of a number theorist is sorting a large pile of pennies (worth less\nthan a dollar) into groups of 3 pennies each. At the end, the child reports that\n2 pennies are left over. The child starts over, instead sorting the pennies into\ngroups of 4, and reports that 1 penny is left over. The child starts over again,\nsorting the pennies into groups of 11, and reports that 7 pennies are left over.\nThe number theorist didn’t originally know how many pennies were in the\npile, but at this point, she speaks up. What does she say? Did the child make\na mistake in sorting the pennies? Or does the number theorist have enough\ninformation to tell how many pennies are in the pile?"
      },
      {
        text:
          "Using the extended Euclidian algorithm, find the multiplicative inverse of 7465 mod 2464."
      },
      {
        text:
          "State and use the Fermat’s theorem to find 4^225 mod 13."
      }
    ]}
    exampleVideos={[]}
  />
);

export default FundamentalsOfNumberTheoryModule;
